module.exports = __webpack_public_path__ + "catalog/items/furniture/Sofa2/Sofa2.svg";